//LOGIN
export const POST_LOGIN = "/authentication/login";
export const POST_RESYNC = "/authentication/resync";
export const LOGOUT = "/authentication/logout";

// Apps
export const GET_APPS = "/user/apps";
